<app-text-input [label]="'Lösenord'" [type]="'password'" [model]="password" (model)="password = $event"></app-text-input>
<app-text-input [label]="'Bekräfta lösenord'" [type]="'password'" [model]="confirmPassword" (model) ="confirmPassword = $event"></app-text-input>
<app-error-message>{{errorMessage}}</app-error-message>
<button mat-raised-button color="primary" (click)="setPassword()">Sätt lösenord</button>
